import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
} from "@mui/material";
import { ReactElement, useState } from "react";

import { IntegrationServiceType } from "~frontend/__generated__/graphql";
import DialogCloseButton from "~frontend/components/DialogCloseButton";
import Select from "~frontend/components/forms/FormSelect";
import { useFeatureFlag } from "~frontend/providers/LoggedInUserProvider/context";

import { AfterClose } from ".";
import { integrationComponents, integrationLabels } from "./types";

export function AddIntegrationDialog({
  open,
  onClose,
  subaccountId,
  hasDDxIntegration,
}: {
  open: boolean;
  onClose: (oneTimeData?: any) => void;
  subaccountId: string;
  hasDDxIntegration: boolean;
}): ReactElement {
  const [integrationType, setIntegrationType] =
    useState<null | IntegrationServiceType>(null);

  const [isPostCreate, setIsPostCreate] = useState(false);

  const enableDDxIntegration = useFeatureFlag("enableDDxIntegration");

  const availableIntegrationTypes = (
    Object.keys(integrationLabels) as IntegrationServiceType[]
  ).filter(type => {
    if (type === IntegrationServiceType.DdxExport) {
      return enableDDxIntegration && !hasDDxIntegration;
    }
    return true;
  });

  const IntegrationComponent =
    integrationType && integrationComponents[integrationType];

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Add a New Integration</DialogTitle>
      <DialogContent sx={{ minWidth: "400px" }}>
        <DialogCloseButton
          onClose={() => {
            setIsPostCreate(false);
            onClose();
          }}
        />
        <Box>
          <Select
            label="Service Provider"
            value={integrationType || ""}
            onChange={e =>
              setIntegrationType(
                (e.target.value as IntegrationServiceType) || null
              )
            }
            fullWidth
            disabled={isPostCreate}
          >
            {availableIntegrationTypes.map(serviceOption => (
              <MenuItem key={serviceOption} value={serviceOption}>
                {integrationLabels[serviceOption]}
              </MenuItem>
            ))}
          </Select>
          {IntegrationComponent && (
            <IntegrationComponent
              integration={null}
              subaccountId={subaccountId}
              afterCreate={() => setIsPostCreate(true)}
              onClose={(afterClose?: AfterClose) => {
                setIsPostCreate(false);
                onClose(afterClose);
              }}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
